import React from "react";



function FacultyHeader() {
    const today = new Date();
    const formattedDate = today.toLocaleDateString("en-GB");      // DD/MM/YYYY

    return (
        <>

            <div className="fac-header-bar d-flex justify-content-between align-items-center">

                <div>
                    <img
                        src="../images/ap-logo.webp"
                        alt="AP Logo"
                        className="fac-header-logo"

                    />
                </div>

                <div className="fac-header-title-wrapper">
                    <h4 className="fac-header-title">
                        Commissioner, Collegiate Education
                    </h4>
                </div>

            </div>
        </>

    );
}
export default FacultyHeader;